class NumZoom extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this._zoomed = false;
    this._carousel = null;
    this._startX = 0;
    this._startY = 0;
    this._currentX = 0;
    this._currentY = 0;
    this._image = null;
    this._overlay = null;
  }

  connectedCallback() {
    this._render();
    this._image = this.shadowRoot.querySelector('slot').assignedElements()[0];
    this._overlay = this.shadowRoot.querySelector('.zoom-overlay');
    this._attachEventListeners();
  }

  _attachEventListeners() {
    if (this._image) {
      this._image.addEventListener('click', (e) => this._toggleZoom(e));

      // Add movement listeners only when zoomed
      this._image.addEventListener('mousedown', (e) => this._startMove(e));
      this._image.addEventListener('touchstart', (e) => this._startMove(e));
    }

    document.addEventListener('mouseup', (e) => this._stopMove(e));
    document.addEventListener('mousemove', (e) => this._move(e));
    document.addEventListener('touchmove', (e) => this._move(e));
    document.addEventListener('touchend', (e) => this._stopMove(e));

    this._overlay.addEventListener('click', (e) => this._toggleZoom(e));
  }

  _startMove(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this._zoomed) return;

    const event = e.touches ? e.touches[0] : e;
    this._startX = event.clientX - this._currentX;
    this._startY = event.clientY - this._currentY;

    this._image.style.cursor = 'grabbing';
  }

  _move(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this._zoomed || e.buttons !== 1) return;

    const event = e.touches ? e.touches[0] : e;
    this._currentX = event.clientX - this._startX;
    this._currentY = event.clientY - this._startY;

    this._image.style.transform = `scale(2) translate(${this._currentX}px, ${this._currentY}px)`;
  }

  _stopMove(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this._zoomed) return;

    this._image.style.cursor = 'zoom-out';
  }

  _toggleZoom(e) {
    e.preventDefault();
    e.stopPropagation();
    this._zoomed = !this._zoomed;
    this._image.classList.toggle('zoomed', this._zoomed);
    this._overlay.classList.toggle('active', this._zoomed);

    // Reset position when zoom is toggled off
    if (!this._zoomed) {
      this._currentX = 0;
      this._currentY = 0;
      this._image.style.transform = '';
    }
  }

  reset() {
    this._zoomed = false;
    this._image.classList.remove('zoomed');
    this._overlay.classList.remove('active');
    this._currentX = 0;
    this._currentY = 0;
    this._image.style.transform = '';
  }

  _render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          position: relative;
          cursor: zoom-in;
        }
        .zoom-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          z-index: 9999;
        }
        .zoom-overlay.active {
          display: block;
        }
        ::slotted(img) {
          display: block;
          position: relative;
          z-index: 10000;
          width: 100%;
          height: auto;
          transition: transform 0.3s ease;
        }
        ::slotted(img.zoomed) {
          transform: scale(2);
          cursor: zoom-out;
        }
      </style>
      <div class="zoom-overlay"></div>
      <slot></slot>
    `;
  }
}

customElements.define('num-zoom', NumZoom);
